import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SettingsContext = createContext({});

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({});
  useEffect(() => {
    axios
      .get(`${API}/site-settings`)
      .then((r) => setSettings(r.data || {}))
      .catch(() => {});
  }, []);
  return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>;
};

export const useSiteSettings = () => useContext(SettingsContext);

const SegmentContext = createContext(null);

export const SegmentProvider = ({ children }) => {
  const [segment, setSegment] = useState("bireysel");
  return (
    <SegmentContext.Provider value={{ segment, setSegment }}>
      {children}
    </SegmentContext.Provider>
  );
};

export const useSegment = () => useContext(SegmentContext);

// "#anchor" → smooth scroll, "/path" → router navigate, "http..." → new tab
export const goTo = (href, navigate) => {
  if (!href) return;
  if (href.startsWith("#")) {
    const scroll = () => document.getElementById(href.slice(1))?.scrollIntoView({ behavior: "smooth" });
    if (window.location.pathname !== "/" && navigate) {
      navigate(`/${href}`);
      return;
    }
    scroll();
  } else if (href.startsWith("/")) {
    if (navigate) navigate(href);
    else window.location.href = href;
  } else {
    window.open(href, "_blank", "noopener");
  }
};

export const pick = (obj, base, lang, fallback = "") =>
  obj?.[`${base}_${lang}`] ?? fallback;
